/**
 * @author  : 王冲
 * @desc    : 主框架钩子
 */

import { regHook } from '@weapp/utils';
import { sdkHooksRules } from './sdk';

// 主框架登录跳转连接
export function registerHook<T>(hookname: string, fn: (data: T) => Promise<T>) {
	const hooksRules = [
		'layoutLoginRedirectUrl',
		'canChangeTenant',
		'beforeThemeRender',
		'afterThemeRender',
		'afterLogout',
		'beforeLogout',
		'portalUserIntro'
	].concat(sdkHooksRules);
	const originRuleName = (hookname || '').split('_')[0];
	if (hooksRules.includes(hookname) || (originRuleName && hooksRules.includes(originRuleName))) {
		regHook('weappLayout', hookname, fn)
	} else {
		console.log('error hookname');
	}
}